export enum CartMutationTypes {
    SET_CART = 'SET_CART',
    SET_SHOW_CART_POLICY = 'SET_SHOW_CART_POLICY',
    SET_FREE_PRODUCT_DISABLE_FLAG = 'SET_FREE_PRODUCT_DISABLE_FLAG',
    SER_REFRESH_CART = 'SER_REFRESH_CART'
}
